module.exports = __webpack_public_path__ + "8ddb062b0202fc640069d725d84581df.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarChloe6.png
// module id = 60
// module chunks = 0